import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeripheralsService } from './logic/peripherals.service';
import { PeripheralsLogicService } from './logic/peripherals/peripherals-logic.service';
import { PeripheralsDaoService } from './dao/peripherals-dao.service';
import { PeripheralsDbDaoService } from './dao/peripherals-dao/peripherals-db-dao.service';
import { PeripheralDbTableDefinition } from './dao/peripherals-dao/peripheral-db-table-definition';
import { PeripheralConfigFactoryService } from './peripherals-config-factory';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: PeripheralsService, useClass: PeripheralsLogicService },
     {
      provide: PeripheralsDaoService,
      useClass: PeripheralsDbDaoService
    },
    { provide: PeripheralDbTableDefinition },
    { provide: PeripheralConfigFactoryService }
  ]
})
export class PeripheralsServiceModule {}
